import * as React from 'react';

export default function Example() {
  React.useEffect(() => {
    window.location.href = 'https://tools.oneshop.com/blog/poshmark-share-group';
  }, []);
  return null;
}
